'use client'

import { Box, Text } from '@chakra-ui/react'
import { FC } from 'react'

export type QuoteCardProps = {
  text: string
  author: string
}

export const QuoteCard: FC<QuoteCardProps> = ({ text, author }) => {
  return (
    <Box
      p={{ base: 6, md: 10 }}
      bg="whiteAlpha.50"
      border="1px solid"
      borderColor="border.dark"
      borderRadius="card"
      minW={{ base: '300px', md: '350px' }}
      maxW="400px"
      flexShrink={0}
    >
      <Text
        fontFamily="display"
        fontSize="1.2rem"
        fontStyle="italic"
        fontWeight={400}
        lineHeight={1.6}
        mb={6}
        color="whiteAlpha.900"
      >
        &ldquo;{text}&rdquo;
      </Text>
      <Text fontSize="0.9rem" color="whiteAlpha.500">
        {author}
      </Text>
    </Box>
  )
}
